import type { RadioInputStepInput, RenderableFormItem } from "./form-types";

export function isRadioInput(
  input: RenderableFormItem,
): input is RadioInputStepInput {
  return input._type === "radioInput";
}
